/* CUSTOM PRODUKTTABS
Initialisiert die Tab-Navigation der Produktdetailseite inklusive
ARIA-Status, Panel-Umschaltung und Tastatursteuerung. */

(() => {
  /* CUSTOM TAB-INITIALISIERUNG
  Bindet pro Container genau einmal die Tabs und Panels zusammen. */
  function initCustomProductTabs(root = document) {
    const containers = Array.from(root.querySelectorAll("[data-custom-product-tabs]"));

    if (!containers.length) {
      return;
    }

    containers.forEach((container) => {
      if (container.dataset.customProductTabsInit === "1") {
        return;
      }

      const tabs = Array.from(container.querySelectorAll('[role="tab"][data-custom-tab-target]'));
      const panels = Array.from(container.querySelectorAll('[role="tabpanel"][data-custom-tab-panel]'));

      if (!tabs.length || !panels.length) {
        return;
      }

      container.dataset.customProductTabsInit = "1";

      /* CUSTOM TAB-AKTIVIERUNG
      Schaltet den aktiven Tab und das zugehoerige Panel um
      und meldet sichtbare Panels an nachgelagerte Features. */
      const activateTab = (nextTab, { focus = false } = {}) => {
        const target = nextTab.getAttribute("data-custom-tab-target");

        if (!target) {
          return;
        }

        tabs.forEach((tab) => {
          tab.classList.remove("is-active");
          tab.setAttribute("aria-selected", "false");
          tab.setAttribute("tabindex", "-1");
        });

        panels.forEach((panel) => {
          panel.classList.remove("is-active");
          panel.setAttribute("hidden", "true");
        });

        nextTab.classList.add("is-active");
        nextTab.setAttribute("aria-selected", "true");
        nextTab.setAttribute("tabindex", "0");

        const activePanel = container.querySelector(`[data-custom-tab-panel="${target}"]`);

        if (activePanel) {
          activePanel.classList.add("is-active");
          activePanel.removeAttribute("hidden");
          activePanel.dispatchEvent(
            new CustomEvent("custom:product-tabs:panel-shown", {
              bubbles: true,
            })
          );
        }

        if (focus) {
          nextTab.focus();
        }
      };

      /* CUSTOM TASTATURSTEUERUNG
      Unterstuetzt die ueblichen Tablist-Tasten gemaess WCAG/ARIA. */
      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          activateTab(tab);
        });

        tab.addEventListener("keydown", (event) => {
          let nextIndex = null;

          if (event.key === "ArrowRight") {
            nextIndex = (index + 1) % tabs.length;
          } else if (event.key === "ArrowLeft") {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (event.key === "Home") {
            nextIndex = 0;
          } else if (event.key === "End") {
            nextIndex = tabs.length - 1;
          } else if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            activateTab(tab);
            return;
          }

          if (nextIndex === null) {
            return;
          }

          event.preventDefault();
          activateTab(tabs[nextIndex], { focus: true });
        });
      });

      const preselected = tabs.find((tab) => tab.getAttribute("aria-selected") === "true");
      activateTab(preselected || tabs[0]);
    });
  }

  /* CUSTOM BOOTSTRAP
  Initialisiert die Tabs beim ersten Laden und nach Section-Reloads im Theme-Editor. */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initCustomProductTabs());
  } else {
    initCustomProductTabs();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initCustomProductTabs(event.target);
  });
})();
